import type { CSSObject } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const buttonOverrides = (onDarkBackground?: boolean): CSSObject => ({
  marginBlock: Spacing.M,
  marginInline: 'auto',
  color: onDarkBackground ? '#FFFFFF' : undefined,
})
